import { z } from 'zod'
import { Id, Timestamp } from './common'

/** A connected app: a personal access token, or a connector signed in with OAuth (docs/mcp.md). */
export const McpToken = z.object({
  id: Id,
  name: z.string(),
  kind: z.enum(['pat', 'oauth']),
  /** The first characters of the secret, to tell tokens apart. */
  prefix: z.string(),
  /** For a connector: the name it registered with. */
  client_name: z.string().nullable(),
  expires_at: Timestamp,
  last_used_at: Timestamp.nullable(),
  created_at: Timestamp,
})
export type McpToken = z.infer<typeof McpToken>

export const McpTokenList = z.object({
  tokens: z.array(McpToken),
  /** The address to give an MCP client. */
  endpoint: z.string(),
})
export type McpTokenList = z.infer<typeof McpTokenList>

export const CreateMcpTokenBody = z.object({
  name: z.string().trim().min(1, 'Give the token a name.').max(80),
  expires_in_days: z.number().int().min(1).max(365).default(90),
  /** Asked again: a token signs an app in as you for months. */
  password: z.string().min(1, 'Enter your password.').max(200),
})
export type CreateMcpTokenBody = z.input<typeof CreateMcpTokenBody>

export const CreatedMcpToken = z.object({
  token: McpToken,
  /** Shown once, never again. */
  secret: z.string(),
})
export type CreatedMcpToken = z.infer<typeof CreatedMcpToken>

/** The rider said yes on the consent screen; these came back through the browser, so they are checked again. */
export const McpConsentBody = z.object({
  client_id: z.string().min(1).max(200),
  redirect_uri: z.string().min(1).max(2000),
  code_challenge: z.string().min(1).max(200),
  scope: z.string().max(200).optional(),
  state: z.string().max(2000).optional(),
})
export type McpConsentBody = z.infer<typeof McpConsentBody>

export const McpConsentResponse = z.object({ redirect_to: z.string() })
export type McpConsentResponse = z.infer<typeof McpConsentResponse>
